import { useContext, useMemo } from 'react'
import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { MAX_CAROUSEL_ITEM_COUNT } from './common/constants'
import { LOOKING_FOR_SOMETHING_ELSE_CONTENT } from '../LookingForSomethingElse/constants'
import { trendingCruiseDestinations } from '../TrendingDestinations/constants'
import { CRUISE_UNIFIED_FILTERS } from 'constants/cruise'
import { isManualSortingEnabledFor } from 'selectors/featuresSelectors'
import OfferCarouselLookingForSomethingElse from '../LookingForSomethingElse/OfferCarouselLookingForSomethingElse'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import Places from 'constants/places'
import GeoContext from 'contexts/geoContext'

export const DEFAULT_CRUISE_FILTERS: App.OfferListFilters = {
  offerTypes: ['cruise'],
  frontPageVisibleOnly: true,
  limit: MAX_CAROUSEL_ITEM_COUNT,
  destinationId: Places.Anywhere.id,
}

export const UNIFIED_CRUISE_FILTERS: App.OfferListFilters = {
  offerTypes: CRUISE_UNIFIED_FILTERS.offerTypes,
  holidayTypes: CRUISE_UNIFIED_FILTERS.holidayTypes,
  sortBy: CRUISE_UNIFIED_FILTERS.sortBy,
  limit: MAX_CAROUSEL_ITEM_COUNT,
  destinationId: Places.Anywhere.id,
}

interface Props {
  title?: React.ReactNode
}

function CruiseOfferCarousel(props: Props) {
  const {
    title,
  } = props
  const intl = useIntl()
  const filters = isManualSortingEnabledFor('cruises') ? UNIFIED_CRUISE_FILTERS : DEFAULT_CRUISE_FILTERS
  const { currentRegionCode } = useContext(GeoContext)

  const anywhereLabel = intl.formatMessage({
    id: 'xgsbMHpJ0hZoqyyDo8fb',
    defaultMessage: 'Around the world',
    description: 'Destination label for anywhere/worldwide cruise search',
  })

  const destinations = useMemo(() => {
    return [
      { name: anywhereLabel, destinationId: Places.Anywhere.id },
      ...(trendingCruiseDestinations[currentRegionCode] ?? []),
    ].map((dest) => ({
      value: dest.destinationId!,
      label: dest.name,
    }))
  }, [currentRegionCode, anywhereLabel])

  const to = useMemo(() => {
    return LOOKING_FOR_SOMETHING_ELSE_CONTENT.cruises.to
  }, [])

  const defaultTitle = <FormattedMessage
    id="ATLd-dDHI3xjQEm30tD3"
    defaultMessage="Set sail on the ultimate <i>cruise</i>"
    description="Heading title for the cruise carousel with italicized cruise"
    values={{
      i: (chunks) => <i>{chunks}</i>,
    }}
  />

  return (
    <OfferCardCarouselSection
      filters={filters}
      title={title ?? defaultTitle}
      allLink="/cruises"
      additionalFilters="destinations"
      additionalFilterOptions={destinations}
      defaultFilter={Places.Anywhere.id}
      tileStyle="card-default"
      tileSize="medium"
      data-testid="cruise-carousel"
    >
      <OfferCarouselLookingForSomethingElse to={to} />
    </OfferCardCarouselSection>
  )
}

export default React.memo(CruiseOfferCarousel)
